import React, { Component } from "react"
import styled from "styled-components"
import colors from "../../styles/colors"
import Slider from "react-slick"
import CloseIcon from "../../resources/img/ui/popup/popup-close-green.svg"
import WhiteCloseIcon from "../../resources/img/ui/popup/popup-close-white.svg"
import ReactImageMagnify from "react-image-magnify"
import breakpoints from "../../styles/breakpoints"
import RightArrow from "../../resources/img/ui/arrows/green-arrow-right.svg"
import LeftArrow from "../../resources/img/ui/arrows/green-arrow-left.svg"
import WhiteRightArrow from "../../resources/img/ui/arrows/white-arrow-right.svg"
import WhiteLeftArrow from "../../resources/img/ui/arrows/white-left-arrow.svg"
import { PinchView } from "react-pinch-zoom-pan"
import { withTranslation } from "gatsby-plugin-react-i18next"
import { isVariantImagePackshot } from "../../services/images"

const ProductCarouselImg = styled.div`
  display: none;
  height: 100vh;
  margin: auto;
  z-index: 1;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  > div {
    height: 100vh !important;

    > img {
      height: 100vh !important;
      object-fit: ${(props) => props.$objectFit} !important;
    }

  }
  video {
    height: 100vh;
  }

  @media (min-width: ${breakpoints.lg}) {
    max-width: 1360px;
    display: flex;
  }
`

const MobileProductCarouselImg = styled.div`
  height: 100vh;
  margin: auto;
  z-index: 1;

  div {
    height: 100vh !important;

    img {
      object-fit: ${(props) => props.$objectFit} !important;
    }
  }

  video {
    height: 100vh;
    width: 100%;
  }
  @media (min-width: ${breakpoints.lg}) {
    display: none;
  }
`

const StyledSlider = styled(Slider)`
  height: 100%;

  .slick-track,
  .slick-list {
    height: 100%;
  }
`

const Slide = styled.div`
  width: 100%;
  height: 100vh;
  outline: none;
  border: 0;
`

const CarouselContainer = styled.div`
  height: 100%;
  width: 100%;
  max-height: 100vh;
  display: block;
  position: fixed;
  overflow: hidden;
  top: 0;
  left: 0;
  background: ${colors.beige};
  z-index: 99999;
`

const Close = styled.img`
  height: 12px;
  width: 13px;
  z-index: 1111111111;
  cursor: pointer;
`

const CloseButton = styled.div`
  height: 30px;
  width: 30px;
  position: absolute;
  right: 26px;
  top: 26px;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${colors.white};
  border: 1px solid ${colors.green};
  border-radius: 15px;
  z-index: 1111111111;

  @media (min-width: ${breakpoints.md}) {
    height: 49px;
    width: 49px;
    border-radius: 50px;
    right: 40px;
    top: 42px;
  }

  &:hover,
  &:active,
  &:focus {
    text-decoration: none;
    outline: none;
    box-shadow: none;
    transition: 0.5s;
    background-color: ${colors.green};
  }
`

const Arrow = styled.div`
  display: none;

  @media (min-width: ${breakpoints.md}) {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 49px;
    width: 49px;
    border-radius: 50px;
    cursor: pointer;
    background-color: ${colors.white};
    border: 1px solid ${colors.green};
    z-index: 1111111111;
    text-align: center;
    margin: 0 40px;
    &:hover,
    &:active,
    &:focus {
      text-decoration: none;
      outline: none;
      box-shadow: none;
      transition: 0.5s;
      background-color: ${colors.green};
    }
  }
`

const ArrowsContainer = styled.div`
  position: absolute;
  top: calc(50% - 49px);
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`

const CarouselDots = styled.div`
  position: absolute;
  bottom: 30px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  left: 0;
  right: 0;
  margin-right: auto;
  margin-left: auto;
  @media (min-width: ${breakpoints.md}) {
    display: none;
  }
`

const DotStyled = styled.div`
  z-index: 500;
  height: 14px;
  width: 14px;
  cursor: pointer;
  background: ${(props) =>
    props.$active ? `${colors.white}` : "transparent"};
  border-radius: 50px;
  position: relative;
  margin-bottom: 10px;
  margin-left: 5px;
  margin-right: 5px;
  &::before {
    content: "";
    height: 14px;
    width: 14px;
    cursor: pointer;
    border: 1px solid transparent;
    border-color: ${(props) => props.$active && `${colors.green}`};
    border-radius: 50px;
    position: absolute;
    top: 0;
    left: 0;
    transition: 0.2s;
    z-index: 100;
  }
  &::after {
    content: "";
    height: 8px;
    width: 8px;
    z-index: 50;
    background: ${(props) =>
      props.$active? `${colors.green}` : "rgba(0, 0, 0, 0.35)"};
    cursor: pointer;
    border: 1px solid transparent;
    border-radius: 50px;
    position: absolute;
    top: 3px;
    left: 3px;
    transition: 0.2s;
  }
`

class ZoomPopup extends Component {
  state = {
    slideIndex: this.props.initialSlide,
    icons: {
      left: LeftArrow,
      right: RightArrow,
      close: CloseIcon,
    },
  }

  closePopup() {
    this.props.closePopupFunction()
  }

  moveSlide(diff) {
    const slideIndex = parseInt(this.state.slideIndex) + diff

    this.slider.slickGoTo(slideIndex)
  }

  changeSlide(index) {
    this.slider.slickGoTo(index)
  }

  toggleIcon(type) {
    const types = {
      left: {
        default: LeftArrow,
        toggled: WhiteLeftArrow,
      },
      right: {
        default: RightArrow,
        toggled: WhiteRightArrow,
      },
      close: {
        default: CloseIcon,
        toggled: WhiteCloseIcon,
      },
    }

    let icon = types[type].default
    const icons = this.state.icons
    if (icons[type] === types[type].default) {
      icon = types[type].toggled
    }

    icons[type] = icon

    this.setState({
      icons: icons,
    })
  }

  render() {
    const { sliderImages, t } = this.props

    const settings = {
      dots: false,
      arrows: false,
      infinite: true,
      fade: false,
      swipe: true,
      swipeToSlide: true,
      draggable: true,
      speed: 500,
      touchThreshold: 2.5,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: false,
      initialSlide: this.props.initialSlide,
      beforeChange: (current, next) => this.setState({ slideIndex: next }),
    }

    return (
      <CarouselContainer>
        <StyledSlider ref={(slider) => (this.slider = slider)} {...settings}>
          {sliderImages.map((image) => {
            return (
              <Slide key={image.id}>
                <MobileProductCarouselImg
                  $objectFit={
                    isVariantImagePackshot(image) ? "contain" : "cover"
                  }
                >
                  {(image.altText && !image.altText.includes("cord-")) ||
                  image.file?.contentType?.includes("video") ? (
                    <video
                      src={image.altText || image.file.url}
                      loop
                      muted
                      autoPlay
                      playsInline
                      preload="metadata"
                      aria-label="video"
                    />
                  ) : (
                    <PinchView
                      backgroundColor={colors.beige}
                      maxScale={2}
                      containerRatio={100}
                    >
                      <img
                        src={image.src || image.originalSrc || image.url}
                        alt={"pinch view"}
                        style={{
                          margin: "auto",
                          width: "100%",
                          height: "auto",
                        }}
                      />
                    </PinchView>
                  )}
                </MobileProductCarouselImg>
                <ProductCarouselImg
                  $objectFit={
                    isVariantImagePackshot(image) ? "contain" : "cover"
                  }
                >
                  {image.altText && !image.altText.includes("cord-") ? (
                    <video
                      src={image.altText}
                      loop
                      muted
                      autoPlay
                      playsInline
                      preload="metadata"
                      aria-label="video"
                    />
                  ) : (
                    <ReactImageMagnify
                      {...{
                        isHintEnabled: false,
                        shouldHideHintAfterFirstActivation: false,
                        enlargedImagePosition: "over",
                        enlargedImageContainerStyle: {
                          background: colors.beige,
                        },
                        smallImage: {
                          isFluidWidth: true,
                          src: image.src || image.originalSrc,
                        },
                        largeImage: {
                          src: image.src || image.originalSrc,
                          width: image.width,
                          height: image.height,
                        },
                      }}
                    />
                  )}
                </ProductCarouselImg>
              </Slide>
            )
          })}
        </StyledSlider>
        <ArrowsContainer>
          <Arrow
            onClick={() => this.moveSlide(-1)}
            onMouseEnter={() => this.toggleIcon("left")}
            onMouseLeave={() => this.toggleIcon("left")}
          >
            <img src={this.state.icons.left} alt={t("core.previous")} />
          </Arrow>
          <Arrow
            onClick={() => this.moveSlide(1)}
            onMouseEnter={() => this.toggleIcon("right")}
            onMouseLeave={() => this.toggleIcon("right")}
          >
            <img src={this.state.icons.right} alt={t("core.next")} />
          </Arrow>
        </ArrowsContainer>
        <CarouselDots>
          {sliderImages.map((sliderImage, index) => (
            <DotStyled
              key={index}
              $active={this.state.slideIndex === index ? 1 : 0}
              onClick={this.changeSlide.bind(this, index)}
            />
          ))}
        </CarouselDots>
        <CloseButton
          onClick={(e) => this.closePopup(e)}
          alt={t("core.close")}
          onMouseEnter={() => this.toggleIcon("close")}
          onMouseLeave={() => this.toggleIcon("close")}
        >
          <Close
            src={this.state.icons.close}
            onClick={(e) => this.closePopup(e)}
            alt={t("core.close")}
          />
        </CloseButton>
      </CarouselContainer>
    )
  }
}

export default withTranslation()(ZoomPopup)
